import { useEffect } from "react";
import site from "../data/site";

/**
 * Sets the browser tab title, e.g. "Cadavre Exquis — Charles Ingea".
 * Pass nothing to just show the site name.
 */
export default function useDocumentTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} — ${site.name}` : site.name;
  }, [title]);
}
